var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page --complete" }, [
    _vm.message
      ? _c("div", { staticClass: "flash-message" }, [
          _c("div", { staticClass: "flash-message__content" }, [
            _c("div", { staticClass: "flash-message__type" }, [
              _vm._v("Success"),
            ]),
            _vm._v("\n      " + _vm._s(_vm.message) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "flash-message__close",
              on: { click: _vm.closeFlashMessage },
            },
            [_c("img", { attrs: { src: _vm.closeIcon } })]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("h1", [
        _vm._v(
          _vm._s(
            _vm.__("Great news, your website has ", "bluehost-site-migrator")
          )
        ),
      ]),
      _vm._v(" "),
      _c("h1", [
        _vm._v(
          _vm._s(_vm.__("been cloned successfully! ", "bluehost-site-migrator"))
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.__(
                "Your site has been cloned and is now ready for transfer. To initiate the transfer, you need to copy the transfer key and paste it into the Migration Services page.",
                "bluehost-site-migrator"
              )
            ) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "migration-id-container" }, [
        _c("h2", [_vm._v(_vm._s(_vm.migrationId))]),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "button",
          attrs: { target: "_blank", rel: "noreferrer noopener" },
          on: { click: _vm.copyText },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.__("Copy transfer key", "bluehost-site-migrator")) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("p", [
        _c(
          "a",
          {
            attrs: {
              href: _vm.loginUrl,
              target: "_blank",
              rel: "noreferrer noopener",
            },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.__("Login to Bluehost", "bluehost-site-migrator")) +
                "\n      "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("span", { staticClass: "text-disabled" }, [
          _vm._v(
            _vm._s(_vm.__("Don't have an account?", "bluehost-site-migrator"))
          ),
        ]),
        _vm._v("  \n      "),
        _c(
          "a",
          {
            attrs: {
              href: _vm.signupUrl,
              target: "_blank",
              rel: "noreferrer noopener",
            },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.__("Create account", "bluehost-site-migrator")) +
                "\n      "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      Object.keys(_vm.regions).length > 1
        ? _c("p", { staticClass: "text-disabled" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.__("Choose your country:", "bluehost-site-migrator")
                ) +
                "\n      "
            ),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.countryCode,
                    expression: "countryCode",
                  },
                ],
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.countryCode = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.options, function (option) {
                return _c("option", { domProps: { value: option.value } }, [
                  _vm._v("\n          " + _vm._s(option.text) + "\n        "),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("img", { staticClass: "main-image", attrs: { src: _vm.imageSrc } }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }